if (!customElements.get('adev-review-carousel-block')) {
    customElements.define('adev-review-carousel-block', class adevReviewCarouselBlock extends HTMLElement {
        constructor() {
            super();

            this.carouselEl = this.querySelector('[data-adev-review-carousel-block="carousel"]');
            this.carouselElPrevButton = this.querySelector('[data-adev-review-carousel-block="carousel-prev"]');
            this.carouselElNextButton = this.querySelector('[data-adev-review-carousel-block="carousel-next"]');

            this._resizeObserver = null;
            this._resizeObserverTimeout = null;
        }
        
        initCarousel(){
            let settings = {
                cellAlign: 'left',
                contain: false,
                wrapAround: true,
                prevNextButtons: false,
                pageDots: false,
                adaptiveHeight: false,
                on: {
                    ready: () => {
                        this.carouselEl.classList.add('adev--flickity-ready');
                    },
                    settle: () => {
                        this.carouselEl.classList.add('adev--flickity-ready');
                        this.carouselEl.classList.remove('adev--flickity-moving');
                    },
                    dragStart: () => {
                        this.carouselEl.classList.add('adev--flickity-moving');
                    },
                    dragEnd: () => {
                        this.carouselEl.classList.remove('adev--flickity-moving');
                    }
                }
            };

            this.carouselInstance = new Flickity(this.carouselEl, settings);

            this.initArrows();

            this._resizeObserver = new ResizeObserver(() => {
                this.carouselEl.classList.remove('adev--flickity-ready');
                clearTimeout(this._resizeObserverTimeout);
                this._resizeObserverTimeout = setTimeout(() => {
                    this.carouselEl.classList.add('adev--flickity-ready');
                }, 100);
            });

            this._resizeObserver.observe(this.carouselEl);

            this.classList.add('has--arrows');
        }

        destroyCarousel(){
            if(this.carouselInstance){
                this.carouselInstance.destroy();
                this.carouselInstance = null;
            }
        }

        goPrev(){
            if(this.carouselInstance){
                this.carouselInstance.previous();
            }
        }

        goNext(){
            if(this.carouselInstance){
                this.carouselInstance.next();
            }
        }

        initArrows(){
            if(this.carouselElPrevButton){
                this.carouselElPrevButton.addEventListener('click', this.goPrev.bind(this));
            }

            if(this.carouselElNextButton){
                this.carouselElNextButton.addEventListener('click', this.goNext.bind(this));
            }
        }

        destroyArrows(){
            if(this.carouselElPrevButton){
                this.carouselElPrevButton.removeEventListener('click', this.goPrev.bind(this));
            }

            if(this.carouselElNextButton){
                this.carouselElNextButton.removeEventListener('click', this.goNext.bind(this));
            }
        }

        connectedCallback() {
            this.initCarousel();
        }

        disconnectedCallback() {
            this.destroyCarousel();
            this.destroyArrows();
        }

    });
}